<template>
    <div class="learnlistBox">
        <div v-if="showLoading">
            <van-overlay :show="showLoading"/>
            <div class="loadinglist">
                <van-loading v-if="showLoading" size="24px" vertical>加载中...</van-loading>
            </div>
        </div>
        <div v-else class='learnlist'>
            <van-list
                v-model="loading"
                :finished="finished"
                finished-text=" 一 已经到底了，更多内容即将上线 一 "
                :immediate-check="false"
                ref="list"
                @load="onLoad"
                v-if="trainingList && trainingList.length"
            >
                <ul>
                    <li v-for="(item,index) in trainingList" :key="index" @click="trainingMsg(item)">
                        <div class="learning-list-left">
                            <img class="learning-list-left-img" :src="item.coverUrl" alt="">
                            <div class="_clear">
                                <p class="learning-list-left-new" v-if="item.isNewTask">
                                    <img src="../../../assets/images/learning/new1.png" alt="">
                                    <span>NEW</span>
                                </p>
                                <p class="learning-list-left-rules1" v-if="item.isNewTask && item.taskType">
                                    <img src="../../../assets/images/learning/rules1.png" alt="">
                                    <span>
                                        {{ConstData.taskType[item.taskType].text}}
                                    </span>
                                </p>
                                <p class="learning-list-left-rules" v-if="!item.isNewTask && item.taskType">
                                    <img src="../../../assets/images/learning/rules.png" alt="">
                                    <span>
                                        {{ConstData.taskType[item.taskType].text}}
                                    </span>
                                </p>
                            </div>

                        </div>
                        <div class="learning-list-right">
                            <h4>{{item.name}}</h4>
                            <p class="learning-list-right-time _clear" v-if="item.courseNum>0">
                                <svg-icon icon-class="learnTotalTime-icon" class-name="learnTotalTime-icon"></svg-icon>
                                已学习{{formateTime(item.learnTotalTime)}}小时<span>|</span>完成{{item.studyProcess || 0}}%
                            </p>
                            <p class="learning-list-right-validity" v-if="learnValidity && is_taskTime">{{item.cycleType===3?'长期有效':'有效期至：'+formatTime(item.endTime)}}</p>
                            <p class="learning-list-right-lable _clear">
                                <span v-for="(childItem,childIndex) in item.contentTypeSet" :key="childIndex">
                                    {{ConstData.taskContentType[childItem].text}}
                                </span>
                            </p>
                        </div>
                    </li>
                </ul>
            </van-list>
            <div class="noContent" v-else>
                <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/learning/noContent.png"/>
                <p class="trainging-noContent">您还没有学习内容</p>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name:'',
    data () {
        return {
            showLoading: true,
            loading:false,
            finished:false,
            filter: {
                pageNum: 1,
                pageSize: 20,
                taskStatus: ""
            },
            total: 0,
            trainingList:[],
            is_taskTime:true,
            Task_interface_optimize:false
        };
    },
    props: {
        learnValidity: {
            type: Boolean,
            default: false
        },
    },
    components: {
    },
    created(){
        this.initConfig();
    },
    methods: {
      initConfig(){
          const frontendConfigArr = (sessionStorage.getItem('frontendConfig') && JSON.parse(sessionStorage.getItem('frontendConfig'))) || this.$store.state.dynamic.frontendConfig || [];
          const is_taskTime = frontendConfigArr.length && frontendConfigArr.filter(item => {
              if(item.key === 'is_taskTime'){
                  return true
              }
          })[0];

          this.is_taskTime = is_taskTime && is_taskTime.value === 'true' ? true : false;
          let Task_interface_optimize = frontendConfigArr.length && frontendConfigArr.filter(item => {
              if(item.key === 'Task_interface_optimize'){
                  return true
              }
          })[0];
          this.Task_interface_optimize = Task_interface_optimize.value && Task_interface_optimize.value === 'true' ? true : false;
        },
        /**
         * 上拉加载
         */
        onLoad() {
            this.filter.pageNum = this.filter.pageNum*1 + 1;
            if(this.Task_interface_optimize){
              this.findTaskList('reachBottom')
            }else{
              this.getTrainList('reachBottom')
            }
        },
        formateTime(val) {
            if(val){
                if((val / 3600).toFixed(2)>0){
                    return (val / 3600).toFixed(2);
                }else{
                    return (val / 3600).toFixed(0);
                }

            }else{
                return val;
            }

        },
        trainingMsg(item) {
            if((item.cycleType===1 || item.cycleType===2) && new Date().getTime()<=new Date(item.startTime).getTime()){
                this.$toast({
                  message: '任务还没到开始时间',
                    duration: 2000,
                });
                return;
            }else{
                if(item.isExpired){
                    this.$toast({
                    message: '已到期，无法学习',
                        duration: 2000,
                    });
                }else{
                    // 人脸识别需要
                    localStorage.setItem('faceidentify', 0);
                    localStorage.setItem('firstfaceauth', 0);
                    this.$router.push({
                        path: "/learning/task/detail",
                        query: {
                            id: item.id,
                            backType:1,
                            ishint:1,
                            isNewTask:item.isNewTask,
                        }
                    });
                }

            }


        },
        formatTime(val) {
            if(val){
                return val.split(' ')[0].split('-').join('.');
            }
        },
        selectcheck(value){
            this.filter={
                pageNum: 1,
                pageSize: 20,
                taskStatus: value
            };
            if(this.Task_interface_optimize){
              this.findTaskList()
            }else{
              this.getTrainList()
            }
        },
        // 列表初始化
        findTaskList(type){
          let params = this.filter;
          this.$api.learning.findTaskList({params}).then(async res => {
            this.showLoading = false;
            if(res.data){
                if (type === "reachBottom") {
                    this.trainingList = this.trainingList.concat(res.data.list);
                } else {
                    this.trainingList = res.data.list || [];
                }
                this.total = res.data.total;
                // 加载状态结束
                this.loading = false;
                // 数据全部加载完成
                this.finished = res.data.isLastPage;
                let ids = [];
                this.trainingList.forEach(item => {
                    ids.push(item.id);
                });
                await this.findTaskLearningInfo(ids.join(','));
            }
          }) 
        },
        // 列表二次渲染 返回学习数据--进度百分比
        async findTaskLearningInfo(ids){
          let params = {
            param:ids
          }
          await this.$api.learning.findTaskLearningInfo({params}).then(res => {
            if(res.data){
              this.trainingList.forEach(item => {
                for(let key in res.data){
                  if(Number(key) === item.id){
                      item.contentTypeSet = res.data[key].contentTypeSet;
                      item.studyProcess = res.data[key].studyProcess;
                      item.taskItemTypeList = res.data[key].taskItemTypeList;
                      item.courseNum = res.data[key].courseNum;
                      item.learnTotalTime = res.data[key].learnTotalTime;
                  }
                }
              })
            }
            
            console.log('res==',this.trainingList)
          }) 
        },
        getTrainList(type) {
            let params = this.filter;
            this.$api.learning.trainList({ params }).then((res) => {
                this.showLoading = false
                if(res.data){
                    if (type === "reachBottom") {
                        this.trainingList = this.trainingList.concat(res.data.list);
                    } else {
                        this.trainingList = res.data.list || [];
                    }
                    this.total = res.data.total;
                    // 加载状态结束
                    this.loading = false;
                    // 数据全部加载完成
                    this.finished = res.data.isLastPage;
                }
            });
        },


    },

    mounted(){

    },
}

</script>
<style lang='less'>
@import '../css/learnlist.less';
</style>
